import React from 'react';
import './Quality.css';

interface Certification {
  name: string;
  description: string;
  accent: string; // CSS colour for the top border
}

const certifications: Certification[] = [
  {
    name: 'GMP Certified',
    description:
      'Ensures our manufacturing processes adhere to Good Manufacturing Practices, guaranteeing product safety and consistency.',
    accent: '#2C5F2D',
  },
  {
    name: 'ISO 9001:2015',
    description:
      'Demonstrates our commitment to a robust Quality Management System for continuous improvement and customer satisfaction.',
    accent: '#0057a8',
  },
  {
    name: 'FSSAI Approved',
    description:
      'Compliance with the Food Safety and Standards Authority of India for safe and high-quality food-grade products.',
    accent: '#e67e00',
  },
  {
    name: 'USDA Organic',
    description:
      'Certifies that our organic products meet the stringent standards of the United States Department of Agriculture.',
    accent: '#4a7c3f',
  },
  {
    name: 'EU Organic',
    description:
      'Ensures compliance with the European Union\'s organic farming and production standards for EU market entry.',
    accent: '#003399',
  },
  {
    name: 'Halal & Kosher',
    description:
      'Our products meet the dietary requirements of Halal and Kosher certifications, catering to diverse global markets.',
    accent: '#8b4513',
  },
  {
    name: 'HACCP Certified',
    description:
      'Hazard Analysis and Critical Control Points certification ensures food safety throughout the production process.',
    accent: '#c0392b',
  },
  {
    name: 'Non-GMO',
    description:
      'Guarantees our products are free from genetically modified organisms, ensuring natural and safe ingredients.',
    accent: '#27ae60',
  },
];

const Quality: React.FC = () => {
  return (
    <section className="quality" id="quality">
      <div className="quality-container">
        <h2>Quality Standards & Certifications</h2>
        <p className="quality-intro">
          Every batch we ship meets international regulatory requirements. Our certifications ensure
          that our products are safe, authentic, and compliant with global standards.
        </p>
        <div className="certifications">
          {certifications.map((cert) => (
            <div
              className="certification"
              key={cert.name}
              style={{ borderTopColor: cert.accent }}
            >
              <div className="cert-dot" style={{ backgroundColor: cert.accent }} />
              <h4>{cert.name}</h4>
              <p>{cert.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Quality;
